<template>
    <div id="app">
      <router-view/>
    </div>
</template>

<script>
import { createActive } from "@/api/index"
export default {
    name: 'App',
    data() {
        return {
          time: 0,
          interval: false,
          suTime: 0,
        };
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
    },
    destroyed () {
    },
    created() {
    },
    mounted() {

      document.addEventListener("visibilitychange",() => {
        if (!document.hidden) {   //处于当前页面
          // do something
          if (this.userInfo && this.userInfo._id) {
            this.getTime()
          }
        } else {
          if (this.interval) {
            clearInterval(this.interval)
            this.interval = false
            const time = this.time + 1
            const data = {
               mode: 'time',
               time: time
            }
            createActive(data).then(res=>{
              this.time = 0
            })
          }
        }
      });
    },
    filters: {

    },
    watch: {
      userInfo() {
        if (this.userInfo && this.userInfo._id) {
          this.getTime()
        }
      },
    },
    methods: {

      randomNum(minNum,maxNum){ 
          switch(arguments.length){ 
              case 1: 
                  return parseInt(Math.random()*minNum+1,10); 
              break; 
              case 2: 
                  return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10); 
              break; 
                  default: 
                      return 0; 
                  break; 
          } 
      },

      getTime() {
        this.suTime = this.randomNum(3,9)
        this.interval = setInterval(() => {
          this.time++
          if (this.time % this.suTime == 0) {
            const time = this.time
            const data = {
               mode: 'time',
               time: time
            }
            createActive(data).then(res=>{
              this.time = 0
            })
          }
        },60000)
      },

    },
    components: {

    },
};
</script>

<style>

</style>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/pages/learnspace/App.vue